import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// sections
import FormDialog from './FormDialog';
import TableRow from './TableRow';
// components
import Breadcrumbs from '../../../components/breadcrumbs';
import TableInfo from '../../../components/table-info';
import Pagination from '../../../components/pagination';
import Dialog from '../../../components/dialog';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// utils
import { timezones } from '../../../utils/format';
// assets
import { ReactComponent as Add } from '../../../assets/button/add.svg';
// styles
import { Container, SearchWrapper, Box, PrimaryButton, IconButton, Message, ButtonWrapper, TertiaryButton } from '../../../styles';
// apis
import { getRegisteredGroups, unregisterGroups } from '../../../apis';

// ----------------------------------------------------------------------

const sizes = [10, 20, 30];

// ----------------------------------------------------------------------

export default function OrganizationGroupsPage() {
  const navigate  = useNavigate();
  const state = useLocation().state;
  
  const [ data, setData ] = useState({ content: [], totalElements: 0, totalPages: 1 });
  const { content: rows, totalElements: total, totalPages: pages } = data;

  const [ name, setName ] = useState('');
  const [ page, setPage ] = useState(0);
  const [ size, setSize ] = useState(20);

  const [ dialog, setDialog ] = useState(false);
  const handleClose = () => setDialog(false);
  
  const [ deleteDialog, setDeleteDialog ] = useState(null);
  const [ message, setMessage ] = useState(null);

  const handleDeleteClose = () => setDeleteDialog(null);

  const handleDelete = async () => {
    await unregisterGroups(state.organizationId, deleteDialog)
      .then(() => {
        handleReset();
        setDeleteDialog(null);
      })
      .catch(() => setMessage('요청하신 IoT 장비 그룹을 삭제할 수 없습니다.\n나중에 다시 시도해 주세요.'));
  };
  
  useEffect(() => {
    if ( !state ) return navigate(-1);
    ( async () =>
      await getRegisteredGroups(setData, state.organizationId, name, page, size)
    )();
  }, [state]);

  const handlePage = (value: number) => {
    setPage(value-1);
    getRegisteredGroups(setData, state.organizationId, name, value-1, size);
  };

  const handleSize = (value: number) => {
    setPage(0);
    setSize(value);
    getRegisteredGroups(setData, state.organizationId, name, 0, value);
  };

  const handleSearch = () => {
    if ( name.length > 0 && name.replace(/ /g, '').length === 0 ) return;
    setPage(0);
    getRegisteredGroups(setData, state.organizationId, name, 0, size);
  };

  const handleReset = () => {
    setName('');
    setPage(0);
    getRegisteredGroups(setData, state.organizationId, '', 0, size);
  };

  const cellRender = ({data}: any) => {
    return timezones(data.createdAt, 'YYYY-MM-DD HH:mm:ss');
  };

  if ( !state ) return;
  return (
    <Container>
      <Breadcrumbs
        heading='IoT 장비 그룹'
        links={[
          {name: '계정 관리'},
          {name: '조직', link: '/accounts/organizations'},
          {name: 'IoT 장비 그룹'}
        ]}
      />

      <SearchWrapper>
        <div>
          <input type='text' placeholder='IoT 장비 그룹을 입력하세요.' onChange={(event) => setName(event.target.value)} onKeyDown={(event) => { if(event.key === 'Enter') handleSearch() }} />
          <PrimaryButton type='button' onClick={() => handleSearch()}>검색</PrimaryButton>
        </div>
        <div>
          <IconButton type='button' onClick={() => setDialog(true)}><Add />추가</IconButton>
        </div>
      </SearchWrapper>
      
      <Box>
        <TableInfo total={total} pages={pages} page={page} sizes={sizes} size={size} handleSize={handleSize} />

        <DataGrid
          dataSource={rows}
          noDataText=''
          columnAutoWidth={true}
          paging={{enabled: false}}
        >
          <Column caption='IoT 장비 그룹' dataField='name' alignment='center' />
          <Column caption='설명' dataField='description' alignment='center' />
          <Column caption='등록일' dataField='createdAt' alignment='center' cellRender={cellRender} />
          <Column caption='' alignment='center' cellRender={({data}) => <TableRow row={data} setDeleteDialog={setDeleteDialog} />} />
        </DataGrid>

        <Pagination page={page} pages={pages} size={size} handlePage={handlePage} />
      </Box>

      { dialog &&
        <FormDialog organizationId={state.organizationId} handleClose={handleClose} handleReset={handleReset} />
      }

      { deleteDialog &&
        <Dialog
          title='IoT 장비 그룹 삭제'
          handleClose={handleDeleteClose}
        >
          <p>선택하신 IoT 장비 그룹을 삭제하시겠습니까?</p>

          <Message $visible={message ? true : false}>{ message }</Message>

          <ButtonWrapper>
            <PrimaryButton onClick={() => handleDelete()}>삭제</PrimaryButton>
            <TertiaryButton type='button' onClick={() => setDeleteDialog(null)}>취소</TertiaryButton>
          </ButtonWrapper>
        </Dialog>
      }
    </Container>
  );
}